<router-outlet>

</router-outlet>